<router-outlet>

</router-outlet>